import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ExperienceMotion() {
  const { pathname } = useLocation();
  useEffect(() => {
    const root = document.documentElement;
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    const allowed = () => !media.matches && root.dataset.motion !== 'paused';
    const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if(entry.isIntersecting) { entry.target.classList.add('has-arrived'); reveal.unobserve(entry.target); }
    }), {threshold:0.08});
    document.querySelectorAll('.practice-group,.welcome-founder,.journal-home,.reviews-section,.welcome-booking,.journal-card,.service-focus,.practice-detail-guide,.service-row,.founder-full,.certificate-grid > button,.curriculum-section li,.booking-journey,.order-summary,.service-expect,.founder-letter,.atlas-heading,.observatory-invitation,.practice-guide-items article,.collection-entry').forEach(el => { el.classList.add('arrival'); reveal.observe(el); });
    const scroll = () => {
      if(frame) return;
      frame=requestAnimationFrame(()=>{
        const max=root.scrollHeight-window.innerHeight;
        root.style.setProperty('--page-progress',`${max>0?window.scrollY/max:0}`);
        root.style.setProperty('--scene-scroll',allowed()?`${Math.min(window.scrollY,900)*.16}px`:'0px');
        frame=0;
      });
    };
    const pointer = (event: PointerEvent) => {
      if(!allowed()) return;
      const hero=document.querySelector<HTMLElement>('.celestial-hero');
      if(hero&&event.pointerType==='mouse'){const rect=hero.getBoundingClientRect();if(rect.bottom>0){hero.style.setProperty('--pointer-x',`${(event.clientX/window.innerWidth-.5)*16}px`);hero.style.setProperty('--pointer-y',`${(event.clientY/window.innerHeight-.5)*12}px`);hero.style.setProperty('--light-x',`${event.clientX/window.innerWidth*100}%`);hero.style.setProperty('--light-y',`${(event.clientY-rect.top)/rect.height*100}%`);}}
      const tile=(event.target as Element).closest<HTMLElement>('.practice-group-body li,.service-row,.path-choices button,.plan-option');
      if(tile){const rect=tile.getBoundingClientRect();tile.style.setProperty('--shine-x',`${(event.clientX-rect.left)/rect.width*100}%`);tile.style.setProperty('--shine-y',`${(event.clientY-rect.top)/rect.height*100}%`);}
    };
    window.addEventListener('scroll',scroll,{passive:true});
    window.addEventListener('pointermove',pointer,{passive:true});
    window.addEventListener('pointerdown',pointer,{passive:true});
    window.addEventListener('radian-motion-change',scroll);
    const preference = () => { if(media.matches){root.dataset.motion='paused';window.dispatchEvent(new Event('radian-motion-change'));} };
    media.addEventListener('change',preference);
    scroll();
    return () => {media.removeEventListener('change',preference);reveal.disconnect();cancelAnimationFrame(frame);window.removeEventListener('scroll',scroll);window.removeEventListener('pointermove',pointer);window.removeEventListener('pointerdown',pointer);window.removeEventListener('radian-motion-change',scroll);};
  }, [pathname]);
  return <div className="reading-progress" aria-hidden="true"/>;
}
